import DisqualificationSettings from './DisqualificationSettings';

export default DisqualificationSettings;
